let store = {
  debug: true,
  state: {
    active: false,
    route: null,
    form: null,
    data: null
  },
  clear() {
    this.state.active = false;
    this.state.route = null;
    this.state.form = null;
    this.state.data = null;
  }
};

export default store;
